export type AnimeItem = {
  id: string;
  title: string;
  desc: string;
  category: string;
  tag: string;
  score: string;
  episodes: string;
  status: string;
  image: string;
  badge?: string;
};

export type Episode = {
  id: string;
  title: string;
  episode: string;
  time: string;
  image: string;
  progress?: string;
};

export type BingeCollection = {
  id: string;
  title: string;
  desc: string;
  total: string;
  playtime: string;
  image: string;
  gradient: string;
};

export type Feature = {
  icon: string;
  title: string;
  desc: string;
};

export type Faq = {
  q: string;
  a: string;
};

export type Testimonial = {
  name: string;
  role: string;
  text: string;
  avatar: string;
  tag: string;
};

export const categories = [
  { name: "热血战斗", icon: "ri-fire-line", count: "1,280" },
  { name: "恋爱治愈", icon: "ri-heart-3-line", count: "960" },
  { name: "奇幻冒险", icon: "ri-sparkling-2-line", count: "1,105" },
  { name: "科幻机甲", icon: "ri-rocket-2-line", count: "640" },
  { name: "搞笑日常", icon: "ri-emotion-happy-line", count: "820" },
  { name: "运动竞技", icon: "ri-football-line", count: "410" },
  { name: "悬疑推理", icon: "ri-focus-3-line", count: "530" },
  { name: "萌系治愈", icon: "ri-bear-smile-line", count: "755" },
];

export const hotAnime: AnimeItem[] = [
  {
    id: "anime-01",
    title: "苍穹剑影",
    desc: "少年剑客踏上复仇之路，在层层试炼中觉醒上古剑魂，斩破命运的枷锁。",
    category: "热血战斗",
    tag: "高清",
    score: "9.2",
    episodes: "全26集",
    status: "完结",
    badge: "本周热播",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20determined%20young%20swordsman%20with%20flowing%20silver%20hair%20holding%20a%20glowing%20sword%2C%20dramatic%20orange%20and%20teal%20sky%2C%20dynamic%20action%20pose%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20lighting%2C%20clean%20composition%2C%20high%20quality%20anime%20poster&width=600&height=800&seq=anime-hot-01&orientation=portrait",
  },
  {
    id: "anime-02",
    title: "星海旅人",
    desc: "少女驾驶老旧飞船横渡银河，沿途收集星球传说，只为寻找失落的故乡坐标。",
    category: "科幻机甲",
    tag: "4K",
    score: "9.0",
    episodes: "全32集",
    status: "连载",
    badge: "人气飙升",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20female%20space%20pilot%20in%20orange%20flight%20suit%20beside%20a%20worn%20spaceship%2C%20nebulae%20and%20stars%20background%2C%20teal%20and%20amber%20palette%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%2C%20clean%20anime%20poster%20composition&width=600&height=800&seq=anime-hot-02&orientation=portrait",
  },
  {
    id: "anime-03",
    title: "甜心食堂",
    desc: "落魄厨神重返校园，用一道道暖心料理治愈同学，也找回自己对料理的初心。",
    category: "恋爱治愈",
    tag: "高清",
    score: "8.8",
    episodes: "全24集",
    status: "完结",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20cheerful%20anime%20chef%20girl%20holding%20a%20steaming%20bowl%20of%20ramen%20in%20a%20cozy%20cafeteria%2C%20warm%20orange%20and%20cream%20tones%2C%20soft%20lighting%2C%20vibrant%20cel%20shaded%20illustration%2C%20heartwarming%20clean%20anime%20poster&width=600&height=800&seq=anime-hot-03&orientation=portrait",
  },
  {
    id: "anime-04",
    title: "幻境之塔",
    desc: "探塔小队逐层征服不断重组的幻境，每一层都是一场关于勇气与信任的试炼。",
    category: "奇幻冒险",
    tag: "无广告",
    score: "9.1",
    episodes: "全28集",
    status: "连载",
    badge: "连播推荐",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20an%20adventurer%20party%20standing%20before%20a%20towering%20mystical%20fantasy%20tower%2C%20glowing%20teal%20magic%20and%20warm%20orange%20light%2C%20epic%20scale%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-hot-04&orientation=portrait",
  },
  {
    id: "anime-05",
    title: "球场荣光",
    desc: "弱队后卫与天才前锋并肩作战，用一场场逆风翻盘，书写属于小城的篮球神话。",
    category: "运动竞技",
    tag: "4K",
    score: "8.9",
    episodes: "全50集",
    status: "完结",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20energetic%20basketball%20players%20in%20orange%20jerseys%20mid%20jump%20shot%20in%20a%20packed%20gymnasium%2C%20dramatic%20warm%20lighting%2C%20dynamic%20motion%2C%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster%20composition&width=600&height=800&seq=anime-hot-05&orientation=portrait",
  },
  {
    id: "anime-06",
    title: "迷雾侦探社",
    desc: "少年侦探与神秘女助手联手，在层层迷雾中破解一件件看似无解的都市谜案。",
    category: "悬疑推理",
    tag: "高清",
    score: "9.3",
    episodes: "全22集",
    status: "连载",
    badge: "口碑之作",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20mysterious%20young%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20in%20a%20moody%20neon%20city%20night%2C%20teal%20shadows%20and%20warm%20orange%20highlights%2C%20vibrant%20cel%20shaded%20illustration%2C%20suspenseful%20clean%20anime%20poster&width=600&height=800&seq=anime-hot-06&orientation=portrait",
  },
];

export const newAnime: AnimeItem[] = [
  {
    id: "new-01",
    title: "夏日声优梦",
    desc: "声优新人为了追梦，在试音、排练与友情之间，唱响属于夏天的成长之歌。",
    category: "萌系治愈",
    tag: "高清",
    score: "8.7",
    episodes: "更新至第8集",
    status: "连载",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20joyful%20young%20anime%20girl%20holding%20a%20microphone%20on%20a%20summer%20stage%20with%20bokeh%20lights%2C%20warm%20cream%20and%20orange%20tones%2C%20soft%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-new-01&orientation=portrait",
  },
  {
    id: "new-02",
    title: "机甲少年团",
    desc: "五个性格迥异的少年驾驶老式机甲，共同守护被星陨威胁的家园。",
    category: "科幻机甲",
    tag: "4K",
    score: "9.0",
    episodes: "更新至第12集",
    status: "连载",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20five%20teen%20pilots%20in%20front%20of%20a%20giant%20orange%20mecha%20robot%2C%20dramatic%20sunset%20sky%2C%20vibrant%20cel%20shaded%20illustration%2C%20teal%20and%20amber%20palette%2C%20clean%20anime%20poster%20composition&width=600&height=800&seq=anime-new-02&orientation=portrait",
  },
  {
    id: "new-03",
    title: "神明小饭馆",
    desc: "隐居小镇的小饭馆，每晚都有一位神明光顾，用一餐饭换一个愿望。",
    category: "恋爱治愈",
    tag: "高清",
    score: "8.9",
    episodes: "更新至第6集",
    status: "连载",
    badge: "本周上新",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20gentle%20spirit%20deity%20at%20a%20warm%20lantern%20lit%20little%20restaurant%20table%2C%20cozy%20warm%20orange%20and%20golden%20tones%2C%20soft%20glow%2C%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-new-03&orientation=portrait",
  },
  {
    id: "new-04",
    title: "逆风超能力",
    desc: "全班最普通的少年觉醒了超能力，却发现这份力量只在考试倒数时最强。",
    category: "搞笑日常",
    tag: "无广告",
    score: "8.6",
    episodes: "更新至第10集",
    status: "连载",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20goofy%20grinning%20anime%20school%20boy%20surrounded%20by%20chaotic%20glowing%20energy%20effects%20in%20a%20classroom%2C%20comedy%20style%2C%20bright%20warm%20colors%2C%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-new-04&orientation=portrait",
  },
  {
    id: "new-05",
    title: "白熊邮差",
    desc: "一只白熊邮差踏遍雪原，为山那边的村庄送去温暖的信件与故事。",
    category: "萌系治愈",
    tag: "4K",
    score: "8.8",
    episodes: "全12集",
    status: "完结",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20an%20adorable%20white%20polar%20bear%20mailman%20walking%20through%20a%20snowy%20mountain%20village%20holding%20letters%2C%20soft%20winter%20warm%20lighting%2C%20cream%20and%20orange%20tones%2C%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-new-05&orientation=portrait",
  },
  {
    id: "new-06",
    title: "午后咖啡厅",
    desc: "三位老友合开的街角咖啡厅，用一杯杯咖啡承载平凡而珍贵的日常。",
    category: "恋爱治愈",
    tag: "高清",
    score: "8.5",
    episodes: "更新至第9集",
    status: "连载",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20three%20friends%20enjoying%20coffee%20at%20a%20cozy%20neighborhood%20cafe%20window%2C%20warm%20afternoon%20sunlight%2C%20soft%20cream%20and%20orange%20tones%2C%20vibrant%20cel%20shaded%20illustration%2C%20clean%20anime%20poster&width=600&height=800&seq=anime-new-06&orientation=portrait",
  },
];

export const latestEpisodes: Episode[] = [
  {
    id: "ep-01",
    title: "星海旅人",
    episode: "第13话 · 归途星图",
    time: "2 小时前更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20young%20pilot%20looking%20out%20a%20spaceship%20window%20at%20a%20glowing%20star%20map%2C%20teal%20and%20amber%20nebula%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape%20composition&width=400&height=240&seq=anime-ep-01&orientation=landscape",
  },
  {
    id: "ep-02",
    title: "幻境之塔",
    episode: "第18话 · 心之回廊",
    time: "5 小时前更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20scene%20of%20adventurers%20walking%20through%20a%20glowing%20mirror%20corridor%20inside%20a%20fantasy%20tower%2C%20teal%20magic%20light%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape&width=400&height=240&seq=anime-ep-02&orientation=landscape",
  },
  {
    id: "ep-03",
    title: "迷雾侦探社",
    episode: "第11话 · 消失的钟",
    time: "8 小时前更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20young%20detective%20examining%20a%20mysterious%20old%20clock%20in%20a%20moody%20city%20at%20night%2C%20teal%20and%20orange%20lighting%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape&width=400&height=240&seq=anime-ep-03&orientation=landscape",
  },
  {
    id: "ep-04",
    title: "夏日声优梦",
    episode: "第9话 · 舞台初演",
    time: "昨天更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20scene%20of%20an%20excited%20anime%20girl%20on%20a%20bright%20summer%20stage%20with%20warm%20stage%20lights%20and%20audience%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape&width=400&height=240&seq=anime-ep-04&orientation=landscape",
  },
  {
    id: "ep-05",
    title: "机甲少年团",
    episode: "第12话 · 星陨前夜",
    time: "昨天更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20giant%20orange%20mecha%20standing%20against%20a%20meteor%20falling%20sky%20at%20dusk%2C%20dramatic%20warm%20lighting%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape&width=400&height=240&seq=anime-ep-05&orientation=landscape",
  },
  {
    id: "ep-06",
    title: "逆风超能力",
    episode: "第10话 · 倒数之力",
    time: "3 天前更新",
    image: "https://readdy.ai/api/search-image?query=Anime%20comedy%20scene%20of%20a%20school%20boy%20unleashing%20chaotic%20glowing%20energy%20in%20a%20classroom%2C%20bright%20warm%20colors%2C%20vibrant%20cel%20shaded%20illustration%2C%20cinematic%20landscape&width=400&height=240&seq=anime-ep-06&orientation=landscape",
  },
];

export const bingeCollections: BingeCollection[] = [
  {
    id: "binge-01",
    title: "一口气刷完 · 热血长篇",
    desc: "从第一集到最终回，无广告无缝连播，一次过足战斗瘾。",
    total: "共 186 集",
    playtime: "约 37 小时",
    gradient: "from-primary-500 to-primary-700",
    image: "https://readdy.ai/api/search-image?query=Anime%20panorama%20of%20a%20row%20of%20epic%20battle%20scenes%20with%20fiery%20orange%20energy%20and%20swords%2C%20collage%20of%20heroic%20poses%2C%20vibrant%20cel%20shaded%20illustration%2C%20dramatic%20landscape&width=700&height=420&seq=anime-binge-01&orientation=landscape",
  },
  {
    id: "binge-02",
    title: "治愈连播 · 周末放松",
    desc: "温馨日常一口气连播，适合周末窝在沙发慢慢看。",
    total: "共 94 集",
    playtime: "约 19 小时",
    gradient: "from-accent-500 to-accent-700",
    image: "https://readdy.ai/api/search-image?query=Anime%20panorama%20of%20cozy%20healing%20daily%20life%20scenes%20with%20warm%20light%20cafe%20and%20flowers%2C%20soft%20cream%20and%20teal%20tones%2C%20vibrant%20cel%20shaded%20illustration%2C%20landscape&width=700&height=420&seq=anime-binge-02&orientation=landscape",
  },
  {
    id: "binge-03",
    title: "神作补番 · 口碑合集",
    desc: "评分 9.0+ 的经典神作，高清重制全集收录，一晚上补齐。",
    total: "共 128 集",
    playtime: "约 26 小时",
    gradient: "from-secondary-500 to-secondary-700",
    image: "https://readdy.ai/api/search-image?query=Anime%20panorama%20of%20cinematic%20masterpiece%20moments%20with%20dramatic%20golden%20and%20orange%20cinematic%20lighting%20and%20silhouettes%2C%20vibrant%20cel%20shaded%20illustration%2C%20landscape&width=700&height=420&seq=anime-binge-03&orientation=landscape",
  },
];

export const features: Feature[] = [
  { icon: "ri-eye-2-line", title: "高清画质", desc: "支持 1080P 至 4K 高清晰度，画面细腻，追番体验更沉浸。" },
  { icon: "ri-forbid-2-line", title: "全程无广告", desc: "页面纯净无干扰，片头片尾都不插播，专注内容不打断。" },
  { icon: "ri-speed-up-line", title: "秒开流畅", desc: "多线路智能调度，缓冲迅速、播放稳定，告别卡顿转圈。" },
  { icon: "ri-play-list-2-line", title: "全集连播", desc: "支持一口气连播模式，按顺序自动续播，连续补番超省心。" },
  { icon: "ri-device-line", title: "多端同步", desc: "手机、平板、电脑皆可看，观看进度自动记住，随时接续。" },
  { icon: "ri-bookmark-3-line", title: "追番收藏", desc: "一键收藏心仪番剧，更新提醒实时送达，不错过任何一集。" },
];

export const faqs: Faq[] = [
  {
    q: "卡通动漫综合免费看是真的吗？",
    a: "是的。本站提供海量卡通动漫综合内容免费在线观看，无需付费、无需注册即可直接开刷，方便您随时开始连续补番。",
  },
  {
    q: "画质能有多清晰？",
    a: "我们提供从 1080P 到 4K 的高清片源，并支持自动匹配设备最佳画质。您可以在播放器中手动切换清晰度，享受卡通动漫综合高清体验。",
  },
  {
    q: "页面真的没有广告吗？",
    a: "是的，本站坚持全程无广告。观看过程中不会出现贴片、插播或弹窗干扰，让您专注享受流畅的追番过程。",
  },
  {
    q: "什么是“一口气连播”模式？",
    a: "开启连播后，系统会按照剧集顺序自动播放下一集，无需手动点击，方便您一口气追完卡通动漫综合全集，连续补番更省心。",
  },
  {
    q: "观看需要安装任何软件吗？",
    a: "不需要。本站基于网页直接播放，兼容手机、平板和电脑浏览器，无需下载任何 App 或插件，打开即可观看。",
  },
  {
    q: "会收藏我的观看进度吗？",
    a: "会的。在支持账号登录时，您的观看进度和收藏列表会云端同步，换设备也能无缝接续上次看到的位置。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿岚",
    role: "补番达人",
    text: "页面真的超干净，没有乱七八糟的广告。一口气连播模式太爽了，周末一个下午就补完了一整部热血长篇。",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20portrait%20avatar%20of%20a%20cool%20young%20man%20with%20orange%20hair%20smiling%2C%20flat%20minimal%20vibrant%20style%2C%20clean%20background&width=160&height=160&seq=avatar-01&orientation=squarish",
    tag: "一口气追番",
  },
  {
    name: "小鹿",
    role: "日常番爱好者",
    text: "画质很清楚，治愈系的片源也全。关键是真的不卡，缓存超快，体验比很多大站都好。",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20portrait%20avatar%20of%20a%20gentle%20anime%20girl%20with%20long%20brown%20hair%20smiling%2C%20soft%20warm%20flat%20style%2C%20clean%20background&width=160&height=160&seq=avatar-02&orientation=squarish",
    tag: "高清无广告",
  },
  {
    name: "阿凯",
    role: "机甲宅",
    text: "机型番全收集，还能全季连播。多端同步很实用，公司摸鱼看、回家接着看，进度一点没丢。",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20portrait%20avatar%20of%20an%20energetic%20young%20man%20with%20short%20spiky%20hair%20and%20glasses%20grinning%2C%20flat%20vibrant%20style%2C%20clean%20background&width=160&height=160&seq=avatar-03&orientation=squarish",
    tag: "流畅不卡",
  },
];

export const trendingTitles = [
  "苍穹剑影", "星海旅人", "幻境之塔", "迷雾侦探社", "夏日声优梦",
  "机甲少年团", "白熊邮差", "神明小饭馆", "逆风超能力", "甜心食堂",
];